import React, { useContext } from 'react';
import { useAutoUpdate, usePlayerTimes } from '@24i/player-utils-react';
import { formTimeString, areProgramMetadataValid } from '@24i/player-utils';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { PlayerUIContext, formatVodTimeText } from '@24i/player-ui';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Time } from './styled';
export const RemainingTime = ({ playerInstance, programRange, showHours = true, className = '', formatString = (timeString) => `- ${timeString}`, style = null, }) => {
    var _a, _b;
    const { end } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.timeshiftRange) || { end: 0 };
    const { programStart, programEnd } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.getMetadata()) || {
        programStart: 0,
        programEnd: 0,
    };
    const rangeStart = (_a = programRange === null || programRange === void 0 ? void 0 : programRange.start) !== null && _a !== void 0 ? _a : programStart;
    const rangeEnd = (_b = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _b !== void 0 ? _b : programEnd;
    const metadataValid = areProgramMetadataValid(rangeStart, rangeEnd);
    const isLive = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live;
    const { elapsedTime, durationTime } = usePlayerTimes(playerInstance);
    const timestamp = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.getUTCTimestamp(elapsedTime);
    const { state: { isVolumeOpened }, } = useContext(PlayerUIContext);
    useAutoUpdate();
    let timeString;
    if (!isLive) {
        const remainingTime = durationTime - elapsedTime;
        timeString = formatString(formatVodTimeText(remainingTime, showHours));
    }
    else if (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.isOnLiveEdge(elapsedTime)) {
        timeString = 'LIVE';
    }
    else if (timestamp && metadataValid) {
        timeString = formTimeString(rangeEnd - timestamp.getTime(), showHours !== false);
    }
    else {
        let milliseconds = end - elapsedTime;
        if (metadataValid) {
            milliseconds += rangeEnd - Date.now();
        }
        timeString = formatString(formTimeString(milliseconds, showHours !== false));
    }
    const { theme } = useTheme();
    return (React.createElement(Time, { "data-test": "RemainingTime-Time", className: `RemainingTime ${className}`, isVolumeOpened, style: Object.assign(Object.assign({}, getFont(theme, 'h5')), style), theme: theme }, timeString));
};
//# sourceMappingURL=index.js.map